import React, { useEffect, useState } from "react";
import styled from "styled-components";

import requests from "../../axios/requests";

const LegalPage_ = styled.div`
  background: #f3f3f3;
  padding: 60px 15px 100px 15px;

  .h1 {
    margin: 0 auto 16px auto;
    max-width: 700px;
    text-align: center;
    font-family: RfdBold, sans-serif;
    font-weight: 700;
    font-size: 38px;
    line-height: 46px;
    color: #1d1d1d;
  }

  .updated {
    margin: 0 auto 50px auto;
    width: fit-content;
    font-size: 14px;
    color: var(--text_green);
  }

  .border {
    margin: 50px 0;
    width: 100%;
    height: 1px;
    background: var(--text_green);
  }

  @media (max-width: 820px) {
    padding: 30px 15px 60px 15px;

    .h1 {
      font-size: 22px;
      line-height: 26px;
    }
  }
`;

const Content_ = styled.div`
  max-width: 800px;
  width: 100%;
  margin: 0 auto;

  h1,
  h2,
  h3 {
    margin: 36px 0 12px;
    font-family: RfdBold, sans-serif;
    font-weight: 700;
    color: var(--green);
  }

  h1:first-child,
  h2:first-child,
  h3:first-child {
    margin-top: 0;
  }

  h1 {
    font-size: 26px;
    line-height: 32px;
  }

  h2 {
    font-size: 20px;
    line-height: 26px;
  }

  h3 {
    font-size: 17px;
    line-height: 22px;
  }

  p {
    margin-bottom: 16px;
    font-size: 16px;
    line-height: 24px;
    color: #1d1d1d;
  }

  ul,
  ol {
    margin: 0 0 16px;
    padding-left: 22px;
    font-size: 16px;
    line-height: 24px;
    color: #1d1d1d;
  }

  li {
    margin-bottom: 6px;
  }

  blockquote {
    margin: 0 0 16px;
    padding-left: 16px;
    border-left: 3px solid var(--text_green);
    font-style: italic;
    color: #1d1d1d;
  }
`;

// Показывается при любой ошибке получения документа (404/5xx/сеть) —
// технические детали (код ошибки, стек) пользователю не показываем.
const Unavailable_ = styled.div`
  padding: 100px 15px;
  text-align: center;
  font-family: RfdBold, sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #1d1d1d;
`;

export const LegalPageLayout = ({ slug }) => {
  const [doc, setDoc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    setDoc(null);
    setFailed(false);

    requests
      .fetch_legal_document(slug, { signal: controller.signal })
      .then((res) => setDoc(res.data))
      .catch((err) => {
        // запрос отменён из-за смены slug/размонтирования — это не ошибка,
        // актуальный запрос уже обрабатывается отдельным эффектом
        if (err.code === "ERR_CANCELED") return;
        console.error(err);
        setFailed(true);
      });

    return () => controller.abort();
  }, [slug]);

  if (failed) {
    return (
      <LegalPage_>
        <Unavailable_>Документ временно недоступен</Unavailable_>
      </LegalPage_>
    );
  }

  return (
    <LegalPage_>
      <div className="h1">{doc?.title}</div>
      {doc?.updated_at && <div className="updated">Обновлено: {doc.updated_at}</div>}
      <Content_ dangerouslySetInnerHTML={{ __html: doc?.content || "" }} />
    </LegalPage_>
  );
};
